import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { TieuDeKPINhanVien } from '../../models/kpi/TieuDeKPI';
import { layDSTieuDeKPI, luuDSTieuDeKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

// Một dòng công việc đang chỉnh sửa trong modal
interface TieuDeEdit {
    key: number;
    id?: number;
    noiDung: string;
}

// Chuyển thứ tự sang số La Mã (I, II, III, ...)
const soLaMa = (so: number): string => {
    const bangSo: Array<[number, string]> = [
        [100, "C"], [90, "XC"], [50, "L"], [40, "XL"],
        [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"]
    ];
    var conLai = so;
    var ketQua = "";
    bangSo.forEach(([giaTri, kyHieu]) => {
        while (conLai >= giaTri) {
            ketQua += kyHieu;
            conLai -= giaTri;
        }
    });
    return ketQua;
}

const QuanLyTieuDeKPI = ({ tuKhoa, idDonVi, isEdit }: { tuKhoa: string, idDonVi?: number, isEdit?: boolean }) => {
    const dispatch = useDispatch();
    const [data, setData] = useState<Array<TieuDeKPINhanVien>>([]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [nhanVienChon, setNhanVienChon] = useState<TieuDeKPINhanVien | null>(null);
    const [dsTieuDe, setDsTieuDe] = useState<Array<TieuDeEdit>>([]);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            var rs = await layDSTieuDeKPI();
            setData(rs || []);
        } catch (error: any) {
            toast.error("Không lấy được danh sách công việc");
        }
        setIsLoadingTable(false);
    }

    const moModalTieuDe = (nhanVien: TieuDeKPINhanVien) => {
        setNhanVienChon(nhanVien);
        setDsTieuDe((nhanVien.dsTieuDe || []).map((item, index) => {
            return { key: index, id: item.id, noiDung: item.noiDung };
        }));
    }

    const dongModalTieuDe = () => {
        setNhanVienChon(null);
        setDsTieuDe([]);
    }

    const themTieuDe = () => {
        setDsTieuDe([...dsTieuDe, { key: Date.now(), noiDung: "" }]);
    }

    const capNhatNoiDung = (key: number, noiDung: string) => {
        setDsTieuDe(dsTieuDe.map(item => item.key === key ? { ...item, noiDung } : item));
    }

    const xoaTieuDe = (key: number) => {
        setDsTieuDe(dsTieuDe.filter(item => item.key !== key));
    }

    // Đổi vị trí 2 công việc để thay đổi thứ tự hiển thị
    const doiViTri = (index: number, viTriMoi: number) => {
        if (viTriMoi < 0 || viTriMoi >= dsTieuDe.length) {
            return;
        }
        var temp = [...dsTieuDe];
        var item = temp[index];
        temp[index] = temp[viTriMoi];
        temp[viTriMoi] = item;
        setDsTieuDe(temp);
    }

    const luuTieuDe = async () => {
        if (nhanVienChon == null) {
            return;
        }
        var dsHopLe = dsTieuDe.filter(item => item.noiDung.trim() !== "");
        if (dsHopLe.length !== dsTieuDe.length) {
            toast.warning("Vui lòng nhập nội dung công việc hoặc xóa dòng trống");
            return;
        }
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            var rs = await luuDSTieuDeKPI({
                idNhanVien: nhanVienChon.idNhanVien,
                dsTieuDe: dsHopLe.map((item, index) => {
                    return { id: item.id, noiDung: item.noiDung.trim(), thuTu: index + 1 };
                })
            });
            setData(data.map(item => item.idNhanVien === nhanVienChon.idNhanVien
                ? { ...item, dsTieuDe: rs } : item));
            toast.success("Lưu công việc thành công!");
            dongModalTieuDe();
        } catch (error: any) {
            toast.error("Đã xảy ra lỗi, lưu công việc không thành công!");
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
    }
    

    useEffect(() => {
        layDuLieu();
    }, []);

    return (<>
        {nhanVienChon != null && <ModalTextForm
            hideFooter
            show={nhanVienChon != null}
            title={`Quản lý công việc - ${nhanVienChon.hoTen}`}
            handleClose={dongModalTieuDe}
        >
            <Row className="form-group" gutter={8}>
                <Col span={24}>
                    <Button
                        className="hrm-btn hrm-btn-warning float-right"
                        icon={<PlusOutlined rev="" />}
                        onClick={themTieuDe}
                    >
                        Thêm
                    </Button>
                </Col>
            </Row>
            {dsTieuDe.length === 0 &&
                <Row className="form-group">
                    <Col span={24}>
                        <i>Nhân viên chưa có công việc nào.</i>
                    </Col>
                </Row>
            }
            {dsTieuDe.map((item, index) =>
                <Row className="form-group" gutter={8} key={item.key} align="middle">
                    <Col span={2}>
                        <label style={{ marginBottom: 0 }}>{soLaMa(index + 1)}.</label>
                    </Col>
                    <Col span={17}>
                        <Input.TextArea
                            autoSize={{ minRows: 1 }}
                            value={item.noiDung}
                            placeholder="Nội dung công việc KPI"
                            maxLength={500}
                            onChange={(e) => capNhatNoiDung(item.key, e.target.value)}
                        />
                    </Col>
                    <Col span={5}>
                        <Space>
                            <Tooltip title="Lên">
                                <Button size="small" disabled={index === 0}
                                    icon={<ArrowUpOutlined rev="" />}
                                    onClick={() => doiViTri(index, index - 1)}
                                />
                            </Tooltip>
                            <Tooltip title="Xuống">
                                <Button size="small" disabled={index === dsTieuDe.length - 1}
                                    icon={<ArrowDownOutlined rev="" />}
                                    onClick={() => doiViTri(index, index + 1)}
                                />
                            </Tooltip>
                            <Tooltip title="Xóa">
                                <Button size="small" type="primary" danger
                                    icon={<DeleteOutlined rev="" />}
                                    onClick={() => xoaTieuDe(item.key)}
                                />
                            </Tooltip>
                        </Space>
                    </Col>
                </Row>
            )}
            <Row>
                <Col span={24}>
                    <Button type="primary" className="float-right" loading={isLoadingBtn}
                        icon={<SaveOutlined rev="" />}
                        onClick={luuTieuDe}
                    >
                        Lưu
                    </Button>
                </Col>
            </Row>
        </ModalTextForm>}
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.filter(item =>
                                    (!tuKhoa || item.hoTen?.toLowerCase().includes(tuKhoa.toLowerCase())) &&
                                    (idDonVi > 1 ? item.idDonVi == idDonVi : true)
                                )}
                                rowKey="idNhanVien"
                                pagination={false}
                                sticky
                            >
                                <Column width="60px" title="STT" key="stt" align="center"
                                    render={(value: any, record: any, index: number) => index + 1}
                                />
                                <Column width="250px"  title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                <Column width="250px" title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                <Column title="Tên công việc" key="dsTieuDe"
                                    render={(value: any, record: TieuDeKPINhanVien) => {
                                        return (record.dsTieuDe || []).length === 0
                                            ? <i>Chưa có công việc</i>
                                            : <ol style={{ marginBottom: 0, paddingLeft: 28, listStyleType: 'upper-roman' }}>
                                                {record.dsTieuDe.map(tieuDe => <li key={tieuDe.id}>{tieuDe.noiDung}</li>)}
                                            </ol>;
                                    }}
                                />
                                {isEdit && < Column width="10%" title="Thao tác" key="action" align="center"
                                    render={(value: any, record: TieuDeKPINhanVien) => {
                                        return <Button type="primary" size="small" title="Quản lý công việc KPI"
                                            icon={<EditOutlined rev="" />}
                                            onClick={() => moModalTieuDe(record)}
                                        >
                                            Sửa
                                        </Button>;
                                    }}
                                />}
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </>);
};

export default QuanLyTieuDeKPI;
